export default function SignupDetailsModal({
  selectedSignup,
  setSelectedSignup,
}) {
  if (!selectedSignup) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-3xl shadow-xl w-full max-w-3xl max-h-[90vh] overflow-y-auto">

        {/* Header */}
        <div className="flex justify-between items-center border-b border-gray-200 p-6">
          <div>
            <h2 className="text-2xl font-bold text-sage-700">
              Customer Details
            </h2>

            <p className="text-gray-500 mt-1">
              {selectedSignup.service || "-"}
            </p>
          </div>

          <button
            onClick={() => setSelectedSignup(null)}
            className="text-2xl text-gray-500 hover:text-red-500"
          >
            ✕
          </button>
        </div>

        {/* Customer Information */}
        <div className="p-6">

          <h3 className="text-xl font-semibold mb-4 text-sage-700">
            Customer Information
          </h3>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-5">

            <InfoCard
              label="Name"
              value={selectedSignup.name}
            />

            <InfoCard
              label="Phone"
              value={selectedSignup.phone}
            />

            <InfoCard
              label="Email"
              value={selectedSignup.email}
            />

            <InfoCard
              label="City"
              value={selectedSignup.city}
            />

            <InfoCard
              label="Pincode"
              value={selectedSignup.pincode}
            />

            <InfoCard
              label="Status"
              value={selectedSignup.status}
            />

          </div>

          <div className="mt-5">
            <InfoCard
              label="Address"
              value={selectedSignup.address}
            />
          </div>

        </div>

        {/* Footer */}

        <div className="border-t border-gray-200 p-5 flex justify-end">

          <button
            onClick={() => setSelectedSignup(null)}
            className="bg-sage-700 text-white px-6 py-3 rounded-full hover:bg-sage-800"
          >
            Close
          </button>

        </div>

      </div>
    </div>
  );
}

function InfoCard({ label, value }) {
  return (
    <div className="bg-gray-50 rounded-2xl p-4 border">
      <p className="text-sm text-gray-500">{label}</p>

      <p className="font-medium text-gray-900 mt-1">
        {value || "-"}
      </p>
    </div>
  );
}